import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APISottocategorie {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }



    getUrlDomainGo(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = "http://localhost:4007/";
        }

        if (location.hostname != "localhost") {

            result = "https://filestransfer.it:4007/";

        }

        return result + nome_metodo;


    }



    async initInsert(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);

        return axios.post(this.getUrlDomain("TwoRecruitSottocategorieInitInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async insertSottocategorie(sottocategoria, user) {

        let formData = new FormData();

        formData.append("username", user);

        for (var key in sottocategoria) {
            formData.append(key, sottocategoria[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitSottocategorieInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async initEdit(id, user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_id", id);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitSottocategorieInitEditApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async updateSottocategorie(sottocategoria, user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_id", id);

        for (var key in sottocategoria) {
            formData.append(key, sottocategoria[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitSottocategorieUpdApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteSottocategorie(user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);


        return axios.post(this.getUrlDomain("TwoRecruitSottocategorieDelApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initFilter(user) {

        let formData = new FormData();

        formData.append("username", user);


        return axios.post(this.getUrlDomain("TwoRecruitProvinceInitFilterApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getCompanyJobmule(user) {

        let formData = new FormData();

        formData.append("username", user);


        return axios.post(this.getUrlDomainGo("getCompanyJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getContractTypeJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomainGo("getContractTypeJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getMinStudyJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomainGo("getMinStudyJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getTypeWorkDayJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomainGo("getTypeWorkDayJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getScopeJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomainGo("getScopeJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getAdsCategoryJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);


        return axios.post(this.getUrlDomainGo("getAdsCategoryJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getAdsSubCategoryJobmule(companyid, idcategory) {

        let formData = new FormData();

        formData.append("companyid", companyid);
        formData.append("idcategory", idcategory);

        return axios.post(this.getUrlDomainGo("getAdsSubCategoryJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getDetailsSkillsJobmule(companyid, username) {

        let formData = new FormData();

        formData.append("companyid", companyid);
        formData.append("username", username);

        return axios.post(this.getUrlDomainGo("getDetailsSkillsJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getRegioneJobmule(companyid) {

        let formData = new FormData();

        formData.append("companyid", companyid);

        return axios.post(this.getUrlDomainGo("getRegioneJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async getProvinciaJobmule(idregione) {

        let formData = new FormData();

        formData.append("idregione", idregione);

        return axios.post(this.getUrlDomainGo("getProvinciaJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

    }

}

export default new APISottocategorie({
    url: "https://services.ebadge.it/public/api/"
})
